export const CCPA_COMPLIANCE = 'ccpa-compliance';
